import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Card,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EditIcon from "@mui/icons-material/Edit";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PhoneIcon from "@mui/icons-material/Phone";
import TelegramIcon from "@mui/icons-material/Telegram";
import WorkIcon from "@mui/icons-material/Work";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { API_URL } from "../../util/url";
import fetchWithAuth from "../../util/fetchWithAuth";

export default function ProfileFormWithEditableBanner() {
  const [form, setForm] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    telegram: "",
    salary_amount: "",
    salary_date: new Date().toISOString().split("T")[0],
    birthday_date: "",
    phone_number: "",
    date_of_start: new Date().toISOString().split("T")[0],
    card_number: "",
    role: "operator",
    status: "active",
  });

  const [saving, setSaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const generatePassword = () => {
    const chars =
      "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%^&*";
    const length = 14;
    const bytes = new Uint32Array(length);
    if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (let i = 0; i < length; i += 1) {
        bytes[i] = Math.floor(Math.random() * chars.length);
      }
    }
    let password = "";
    for (let i = 0; i < length; i += 1) {
      password += chars[bytes[i] % chars.length];
    }
    setForm((prev) => ({ ...prev, password }));
  };

  const handleSave = async () => {
    const normalizedUsername = String(form?.username || "").trim();
    if (!normalizedUsername) {
      alert("Логін обов'язковий");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...form,
        username: normalizedUsername,
      };
      await fetchWithAuth(`${API_URL}/user/operators/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      alert("Оператора створено успішно!");
    } catch (err) {
      console.error(err);
      alert("Помилка при створенні оператора");
    } finally {
      setSaving(false);
    }
  };
  const fieldStyle = { display: "flex", alignItems: "center", gap: 2 };
  const labelStyle = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: { xs: 92, md: 140 },
    color: "white",
    fontWeight: 500,
  };
  const CustomTypography = ({ children }) => (
    <Typography variant={"subtitle1"} sx={{ fontSize: "11px" }}>
      {children}
    </Typography>
  );

  return (
    <Box
      component="form"
      autoComplete="new-password"
      sx={{ display: "flex", flexDirection: "column", gap: 3 }}
    >
      <input
        type="text"
        name="fake-username-rmui"
        autoComplete="new-password"
        tabIndex={-1}
        aria-hidden="true"
        style={{
          position: "absolute",
          opacity: 0,
          height: 0,
          width: 0,
          pointerEvents: "none",
        }}
      />
      <input
        type="password"
        name="fake-password-rmui"
        autoComplete="new-password"
        tabIndex={-1}
        aria-hidden="true"
        style={{
          position: "absolute",
          opacity: 0,
          height: 0,
          width: 0,
          pointerEvents: "none",
        }}
      />
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          padding: 2,
          borderRadius: 2,
          backgroundColor: "#1E1E1E",
        }}
      >
        <PersonIcon sx={{ fontSize: 56, color: "white", mr: 2 }} />
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <TextField
              value={form.first_name}
              onChange={handleChange("first_name")}
              placeholder="Ім’я"
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: { color: "white", fontSize: 18, fontWeight: 600 },
              }}
              sx={{ backgroundColor: "transparent", mr: 1 }}
            />
            <TextField
              value={form.last_name}
              onChange={handleChange("last_name")}
              placeholder="Прізвище"
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: { color: "white", fontSize: 18, fontWeight: 600 },
              }}
              sx={{ backgroundColor: "transparent", mr: 1 }}
            />
            <IconButton size="small" sx={{ color: "gray", p: 0.5 }}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography variant="body2" sx={{ color: "gray", mt: 0.5 }}>
            {form.role || "Оператор"}
          </Typography>
        </Box>
      </Card>

      {/* Form */}
      <Card sx={{ p: 3, position: "relative" }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr 1fr" },
            rowGap: 2,
            columnGap: 4,
          }}
        >
          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <PersonIcon sx={{ color: "white" }} />
              <CustomTypography>Логін:</CustomTypography>
            </Box>
            <TextField
              size="small"
              fullWidth
              value={form.username}
              onChange={handleChange("username")}
              required
              name="username"
              autoComplete="username"
              inputProps={{ autoComplete: "username", spellCheck: "false" }}
            />
          </Box>

          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <LockIcon sx={{ color: "white" }} />
              <CustomTypography>Пароль:</CustomTypography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                width: "100%",
                alignItems: "center",
                flexWrap: "nowrap",
              }}
            >
              <TextField
                size="small"
                fullWidth
                type={showPassword ? "text" : "password"}
                value={form.password || ""}
                onChange={handleChange("password")}
                name="new-password"
                autoComplete="new-password"
                inputProps={{ autoComplete: "new-password" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                        aria-label={showPassword ? "Сховати пароль" : "Показати пароль"}
                      >
                        {showPassword ? (
                          <VisibilityOffIcon fontSize="small" />
                        ) : (
                          <VisibilityIcon fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="outlined"
                size="small"
                onClick={generatePassword}
                aria-label="Згенерувати пароль"
                title="Згенерувати пароль"
                sx={{
                  minWidth: 36,
                  px: 0.5,
                  whiteSpace: "nowrap",
                  textTransform: "none",
                  fontSize: 10,
                  height: 32,
                  flexShrink: 0,
                }}
              >
                <AutoFixHighIcon fontSize="small" />
              </Button>
            </Box>
          </Box>

          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <EmailIcon sx={{ color: "white" }} />
              <CustomTypography>Пошта:</CustomTypography>
            </Box>
            <TextField
              size="small"
              fullWidth
              value={form.email}
              onChange={handleChange("email")}
              name="email"
              autoComplete="new-password"
              inputProps={{ autoComplete: "new-password" }}
            />
          </Box>

          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <CalendarTodayIcon sx={{ color: "white" }} />
              <CustomTypography>Дата народження:</CustomTypography>
            </Box>
            <TextField
              size="small"
              fullWidth
              value={form.birthday_date}
              onChange={handleChange("birthday_date")}
              name="birthday_date"
              autoComplete="new-password"
              inputProps={{ autoComplete: "new-password" }}
            />
          </Box>

          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <PhoneIcon sx={{ color: "white" }} />
              <CustomTypography>Телефон:</CustomTypography>
            </Box>
            <TextField
              size="small"
              fullWidth
              value={form.phone_number}
              onChange={handleChange("phone_number")}
              name="phone_number"
              autoComplete="new-password"
              inputProps={{ autoComplete: "new-password" }}
            />
          </Box>

          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <TelegramIcon sx={{ color: "white" }} />
              <CustomTypography>Телеграм:</CustomTypography>
            </Box>
            <TextField
              size="small"
              fullWidth
              value={form.telegram}
              onChange={handleChange("telegram")}
              name="telegram"
              autoComplete="new-password"
              inputProps={{ autoComplete: "new-password" }}
            />
          </Box>

          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <WorkIcon sx={{ color: "white" }} />
              <CustomTypography>Початок роботи:</CustomTypography>
            </Box>
            <TextField
              size="small"
              fullWidth
              value={form.date_of_start}
              onChange={handleChange("date_of_start")}
              name="date_of_start"
              autoComplete="new-password"
              inputProps={{ autoComplete: "new-password" }}
            />
          </Box>

          <Box sx={fieldStyle}>
            <Box sx={labelStyle}>
              <CreditCardIcon sx={{ color: "white" }} />
              <CustomTypography>Номер картки:</CustomTypography>
            </Box>
            <TextField
              size="small"
              fullWidth
              value={form.card_number || ""}
              onChange={handleChange("card_number")}
              name="card_number"
              autoComplete="off"
              inputProps={{ autoComplete: "off" }}
            />
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            variant="contained"
            size="small"
            onClick={handleSave}
            disabled={saving}
            className="textWhite"
            sx={{
              background: "rgb(45deg, #8e2de2)", // фиолетовый градиент
              color: "white",
            }}
          >
            {saving ? "Збереження..." : "Зберегти"}
          </Button>
        </Box>
      </Card>
    </Box>
  );
}
